import { Children, cloneElement } from "react";
import PropTypes from "prop-types";
import useAnimatedTransition from "./useAnimatedTransition";

const AnimatedList = ({ children, disableAnimation = false }) => {
  const childRefs = useAnimatedTransition({
    reactElements: children,
    disableAnimation
  });

  return (
    <ol>
      {Children.map(children, child =>
        cloneElement(child, {
          ref: element => (childRefs.current[child.key] = element)
        })
      )}
    </ol>
  );
};

AnimatedList.propTypes = {
  children: PropTypes.node.isRequired,
  disableAnimation: PropTypes.bool
};

export default AnimatedList;
